// Static "Contact support" page surfaced from the More sheet. Mirrors the
// contact info on the marketing /support page (apps/marketing/src/routes/
// Support.tsx) so owners reach the same channels they saw when they bought.
// Intentionally minimal — no in-app ticket system in V1; we want the owner
// to just message us on the channel they prefer.

import './supportPage.css'

const SUPPORT_EMAIL = 'support@naya.ph'
const SUPPORT_PHONE_DISPLAY = '+63 960 537 5526'
const SUPPORT_PHONE_TEL = '+639605375526'
const SUPPORT_HOURS = 'Mon – Sat\n9am – 6pm PHT'

export function SupportPage() {
  return (
    <div className="owner-support">
      <header className="owner-support-header">
        <h1>Contact support</h1>
        <p className="owner-support-subtitle">
          Reach us through any channel — we reply within 24 hours, usually
          within an hour on business days.
        </p>
      </header>

      <div className="owner-support-grid">
        <ContactRow heading="Email" body={SUPPORT_EMAIL} href={`mailto:${SUPPORT_EMAIL}`} />
        <ContactRow
          heading="Phone / Messenger / Viber"
          body={SUPPORT_PHONE_DISPLAY}
          href={`tel:${SUPPORT_PHONE_TEL}`}
          hint="Smart · Mon – Sat, 9am – 6pm PHT"
        />
        <ContactRow heading="Office hours" body={SUPPORT_HOURS} />
      </div>

      <p className="owner-support-footer">
        Tell us your shop name when you message — it helps us pull up your
        account faster.
      </p>
    </div>
  )
}

function ContactRow({
  heading,
  body,
  href,
  hint,
}: {
  heading: string
  body: string
  href?: string
  hint?: string
}) {
  return (
    <div className="owner-support-row">
      <div className="owner-support-heading">{heading}</div>
      <div className="owner-support-body">
        {href ? <a href={href}>{body}</a> : body}
      </div>
      {hint && <div className="owner-support-hint">{hint}</div>}
    </div>
  )
}
